
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import { PessoaMixin } from "@/modules/Application";
import PessoaData from "./PessoaData";

export default {
  name: "app-contador-update",
  mixins: [PessoaMixin],
  data() {
    return {
      pessoa: new PessoaData({}),
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getInit() {
      try {
        const codigo = this.$route.params.id_pessoa;

        this.setLoading(true);

        const data = await this.getPessoa(codigo);

        this.setLoading(false);

        if (!data.id_pessoa || data == null) {
          this.$router.push({ name: "pessoasLista" });
          return this.$toast.error("Cliente não encontrado!");
        }

        this.pessoa = new PessoaData(data);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
